import { render, staticRenderFns } from "./MonerisCheckout.vue?vue&type=template&id=3c70de60&scoped=true"
import script from "./MonerisCheckout.vue?vue&type=script&lang=js"
export * from "./MonerisCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70de60",
  null
  
)

export default component.exports